import { Box } from '@mui/material'
import styled from 'styled-components'

export const CountryTH = styled.th`
  width: 24px;
  position: relative;
  background-color: white;
`
export const CountryContainer = styled.div`
  bottom: 50px;
  left: -10px;
  position: absolute;
  text-align: left;
  width: 140px;
  transform: rotate(-45deg);
`
export const IndicatorTD = styled.td`
  white-space: nowrap;
  text-align: right;
  padding: 0;
  cursor: pointer;
  font-size: 14px;
  font-family: 'CircularStdBook', sans-serif;
  padding-right: 3px;
  /* width: fit-content; */
`
export const CountryName = styled.span<{
  $active: boolean
}>`
  font-size: 14px;
  font-weight: 500;
  font-family: 'CircularStdMedium' !important;
  cursor: pointer;
  color: ${(props) => (props?.$active ? '#55AFE5' : 'black')};
  white-space: nowrap;
`
export const ColorBox = styled.div<{
  $bg: string
  $active: boolean
}>`
  position: relative;
  height: 22px;
  width: 24px;
  background-color: ${(props) => props.$bg};
  border: ${(props) => (props.$active ? '.4px solid white' : 'none')};
  cursor: pointer;
  box-sizing: border-box;
  overflow: visible;
  transition: all 200ms ease-out;
  box-shadow: ${(props) =>
    props.$active ? '0 4px 8px 0 rgba(85, 175, 229, 0.5), 0 6px 20px 0 rgba(85, 175, 229, 0.5)' : 'none'};
`
